const SEO = [
	{
		page: "home",
		description:
			"Full-Stack MERN Developer skilled in building scalable web applications, secure APIs, and automation solutions. Experienced with React, Node.js, MongoDB, and UI/UX best practices.",
		keywords: [
			"Aryan Vashisht",
			"Aryan MERN Developer",
			"MERN Stack",
			"Full-Stack Developer",
			"React Developer",
			"Node.js Engineer",
			"MongoDB Developer",
			"Frontend Backend Developer",
		],
	},

	{
		page: "about",
		description:
			"Full-Stack Engineer with hands-on experience in MERN, API development, AI-powered automation, and cloud-based solutions. Passionate about clean architecture and system design.",
		keywords: [
			"Aryan Vashisht",
			"Full Stack Developer India",
			"MERN Developer Portfolio",
			"React Node Developer",
			"Software Engineer",
		],
	},

	{
		page: "articles",
		description:
			"Technical articles and engineering insights on MERN stack, backend architecture, JWT auth, performance optimization, and real-world development lessons.",
		keywords: [
			"Aryan Vashisht articles",
			"MERN tutorials",
			"Node.js backend blog",
			"JWT authentication guide",
			"Web development blog",
		],
	},

	{
		page: "projects",
		description:
			"Showcase of real-world full-stack projects including e-commerce platforms, AI-powered apps, and scalable backend systems with modern engineering practices.",
		keywords: [
			"Aryan Vashisht projects",
			"MERN portfolio",
			"React projects",
			"Node.js APIs",
			"Full-Stack portfolio",
		],
	},

	{
		page: "contact",
		description:
			"Looking to collaborate, hire, or discuss a project? Connect with me for full-stack web development, backend services, and automation solutions.",
		keywords: [
			"Contact Aryan Vashisht",
			"Hire MERN Developer",
			"Hire Full-Stack Engineer",
			"React Node developer contact",
		],
	},
];

export default SEO;
